
import Vue from "vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App.vue";
import scroll from 'vue-seamless-scroll'
//组件
import VueMarkdownEditor from '@kangc/v-md-editor'
// import VueMarkdownPriview from '@kangc/v-md-editor/lib/preview'
// import VMdPreviewHtml from '@kangc/v-md-editor/lib/preview-html'
// 组件样式
import '@kangc/v-md-editor/lib/style/base-editor.css'
// import '@kangc/v-md-editor/lib/style/preview.css'
// import '@kangc/v-md-editor/lib/style/preview-html.css'
// 插件
// import createEmojiPlugin from '@kangc/v-md-editor/lib/plugins/emoji/index'
// import createLineNumbertPlugin from '@kangc/v-md-editor/lib/plugins/line-number/index'
// 插件样式
// import '@kangc/v-md-editor/lib/plugins/emoji/emoji.css'
// 主题
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'
// 语言高亮
// import hljs from 'highlight.js/lib/core'
// import json from 'highlight.js/lib/languages/javascript'
// import javascript from 'highlight.js/lib/languages/javascript'
// 高亮的语言
// hljs.registerLanguage('json', json)
// hljs.registerLanguage('javascript', javascript)
// 使用主题
VueMarkdownEditor.use(githubTheme, {
  // Hljs: hljs
})
// 使用插件
// VueMarkdownEditor.use(createEmojiPlugin())
// VueMarkdownEditor.use(createLineNumbertPlugin())
// 注册组件
Vue.use(VueMarkdownEditor)
// Vue.use(VueMarkdownPriview)
// Vue.use(VMdPreviewHtml)



Vue.use(scroll)
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");






// import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// // import VueCropper  from 'vue-cropper'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import VueTinymce from "@packy-tang/vue-tinymce"

// import 'babel-polyfill'
// import Es6Promise from 'es6-promise'
// Es6Promise.polyfill()





// Vue.use(ElementUI)

// Vue.use(VueCropper)

// Vue.use(VueTinymce)

// import Storage from 'vue-ls'
// let storageOptions={
//   namespace: 'pro__', // key prefix
//   name: 'ls', // name variable Vue.[ls] or this.[$ls],
//   storage: 'local', // storage name session, local, memory
// }
// Vue.use(Storage, storageOptions)


// Vue.prototype.msgSuccess = function (msg) {
//   this.$message({ showClose: true, message: msg, type: "success" });
// }
// Vue.prototype.msgWarning = function (msg) {
//   this.$message({ showClose: true, message: msg, type: "warning" });
// }
// Vue.prototype.msgError = function (msg) {
//   this.$message({ showClose: true, message: msg, type: "error" });
// }
// Vue.prototype.msgInfo = function (msg) {
//   this.$message.info(msg);
// }

// Vue.config.productionTip = false

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

